function resolveDefaultPlatforms(authUser) {
  const out = [];
  if (!authUser) return out;
  if (authUser.google_ads_customer_id) out.push('google');
  if (authUser.meta_ad_account_id) out.push('meta');
  return out;
}

/**
 * @param {unknown} platformsArg
 * @param {unknown} authUser
 * @returns {('google'|'meta')[]}
 */
export function normalizePlatformsArg(platformsArg, authUser) {
  if (Array.isArray(platformsArg) && platformsArg.length > 0) {
    return [...new Set(platformsArg.filter((p) => p === 'google' || p === 'meta'))];
  }
  return resolveDefaultPlatforms(authUser);
}

/**
 * FIFO queue of pending optimization runs; same-brand requests merge (union platforms, latest loadCount).
 * @template T
 * @param {Array<{ brandId: string|number, loadCount: () => Promise<T>, platforms: ('google'|'meta')[], resolvers: Array<(r: unknown) => void> }>} queue
 * @param {string|number} brandId
 * @param {() => Promise<T>} loadCount
 * @param {('google'|'meta')[]} platforms
 * @param {(r: unknown) => void} resolve
 */
export function mergePendingBatch(queue, brandId, loadCount, platforms, resolve) {
  const last = queue[queue.length - 1];
  if (last && String(last.brandId) === String(brandId)) {
    const set = new Set([...last.platforms, ...platforms]);
    last.platforms = [...set];
    last.loadCount = loadCount;
    last.resolvers.push(resolve);
  } else {
    queue.push({
      brandId,
      loadCount,
      platforms: [...platforms],
      resolvers: [resolve],
    });
  }
}
